import { render, staticRenderFns } from "./emailMessageForm.vue?vue&type=template&id=f844d23e&scoped=true&"
import script from "./emailMessageForm.vue?vue&type=script&lang=js&"
export * from "./emailMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./emailMessageForm.vue?vue&type=style&index=0&id=f844d23e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f844d23e",
  null
  
)

export default component.exports